<template>
    <div
        :class="applicantTopBlockClasses(user.status)"
        v-if="user"
    >
        <div class="left-side">
            <div class="avatar"

                :style="{'background-image': avatar ? getNameOfAvatar(avatar): `url(/img/add-img.png)`}">

                <img :src="statusLogo(user.status)" alt="" class="status">
                <a href="javascript:void(0)"
                   class="edit-image-btn"
                ><img src="/img/svg/icons-pen-secondary.svg" @click="$refs.imageInput.click()" alt="logo"></a>
                <input
                    type="file"
                    style="display: none"
                    @change="onImageSelected"
                    ref="imageInput"
                    accept="image/*"
                >
            </div>
            <div class="left-side-info">
                <div class="person-info-wrap">
                    <div class="person-info">
                        <div class="name">{{ user.name ?? '' }} {{ user.last_name ?? '' }}</div>
                        <div class="position">{{ user.position.title ?? '' }}</div>
                        <div class="position">

                            <div class="d-flex" v-if="idInput">
                                <input
                                    style="height: 2.125rem"
                                    type="text"
                                    class="form-control"
                                    v-model="newCustomUserId"
                                >
                                <a href="javascript:void(0)"
                                   class="img-btn edit-link ml-2"
                                   @click="saveNewUserId"
                                ><img src="/img/svg/check-5.svg" alt="save">
                                </a>
                            </div>
                            <div class="d-flex" v-else>
                                <p> ID: {{ customUserId ?? '' }}</p>
                                <a href="javascript:void(0)"
                                   v-if="editingApplicantId"
                                   class="img-btn edit-link ml-2"
                                   @click="editUserId(customUserId)"
                                ><img src="/img/svg/icons-pen.svg" alt="edit">
                                </a>
                            </div>
                        </div>
                    </div>

                    <div class="btn-side" v-if="user.status === 'inactive'">
                        <button
                            class="btn btn--outline-primary btn--small"
                            @click="reactivateApplicant"
                        >
                            Activate
                        </button>
                    </div>
                    <div class="btn-side" v-else>
                        <a
                            v-if="deactivatingApplicant"
                            :href="`/master-admin/applicants/${user.id}/deactivate`"
                           class="btn btn--outline-primary btn--small">Deactivate</a>
                    </div>
                </div>
                <div class="tags-wrap-block">
                    <div class="tags-list">
                        <div class="d-flex align-items-center">
                            <div class="tags-wrap" v-if="user.tags">
                                <a
                                    :class="showAll ? `action-link ml-3 ` : `action-link ml-3 collapsed` "
                                    @click="toggleShowAll"
                                    href="javascript:void(0)"><b>
                                    {{user.tags.length}}</b>
                                </a>
                                <div
                                    class="tag-item"
                                    v-for="(tag, index) in user.tags"
                                    :key='tag.id'
                                    v-if="showAll || index  < limit"
                                >
                                    {{ tag.name }}
                                    <button
                                        class="img-btn"
                                        @click="showDeleteModal(tag.id)"
                                    ><img src="/img/svg/on.svg" alt="">
                                    </button>

                                    <ActionModal confirm-text="Yes" reject-text="No"
                                                 :modalId="getDeleteModalId(tag.id)"
                                                 @confirm="deleteTag(tag.id)">
                                        <template #body>
                                            <div class="text-center mb-4">
                                                <h4>
                                                    Are you sure you want <br> to remove tag "{{tag.name}}"
                                                </h4>
                                            </div>
                                        </template>
                                    </ActionModal>

                                </div>
                                <div >
                                    <div class="tag-item tag-item-new" v-show="!inputTag">
                                        <a
                                            href="javascript:void(0)"
                                            @click="showInputTag"
                                        >+ Add New Tag</a>
                                    </div>
                                    <div class="tag-item tag-item-new" v-show="inputTag">
                                        <div class="form-group form-group-tag">
                                            <input
                                                v-model="searchTerm"
                                                @input="search"
                                                type="text"
                                                class="form-control"
                                                placeholder="Search"
                                                ref="textInput"
                                            >
                                            <a
                                                href="javascript:void(0)"
                                                class="edit-link"
                                                @click="saveTag"
                                            ><img src="/img/svg/check-1.svg" alt="search"></a>
                                            <ul
                                                v-show="showResults && searchResults.length"
                                                class="search-results"
                                            >
                                                <li v-for="(result, index) in searchResults"
                                                    :key="index"
                                                    @click="selectResult(result)">
                                                    {{ result }}
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="right-side">
            <div class="contacts">
                <img src="/img/svg/icons-phone.svg" alt="">
                {{ user.cell_number ?? '' }}
            </div>
            <div class="contacts">
                <img src="/img/svg/icons-email.svg" alt="">
                <a :href="`mailto:${user.email}`" class="">{{ user.email ?? '' }}</a>
            </div>
            <div class="contacts" v-if="user.date_applied">
                <img src="/img/svg/icons-calendar.svg" alt="">
                {{ calculateDate(user.date_applied)}}
            </div>
            <div class="contacts" v-else><img src="/img/svg/icons-calendar.svg" alt="">N/A</div>
            <div class="contacts" v-if="user.user_address">
                <img src="/img/svg/icons-location.svg" alt="">
                {{ user.user_address.city ?? '' }}, {{ user.user_address.state ?? '' }}
            </div>
        </div>
    </div>
</template>

<script>
import ApplicantsServices from "./services/ApplicantsServices";
import ActionModal from "../../../../../resources/js/components/ActionModal.vue";
import DeactivationServices from "./services/DeactivationServices";
import CommonService from "../../../AppUser/resources/js/services/CommonService";
import DateConverter from "../../../../../resources/js/mixins/DateConverter";
import ModalHandler from "../../../../../resources/js/mixins/ModalHandler";
import StyleHandler from "../../../../../resources/js/mixins/StyleHandler";

export default {
    name: 'ApplicantInfoBlock',
    components: {ActionModal},
    props: {
        user: {
            type: Object,
            required: true
        },
        deactivatingApplicant: Boolean,
        editingApplicantId: Boolean
    },
    mixins: [DateConverter, ModalHandler, StyleHandler],
    data() {
        return {
            customUserId: this.user.applicant_id ?? null,
            idInput: false,
            newCustomUserId: null,
            tagsList: [],
            inputTag: false,
            showResults: true,
            limit: 3,
            showAll: false,
            searchTerm: null,
            searchResults: [],
            selectedFile: null,
            withPagination: false,
            avatar: this.user.avatar
        }
    },
    methods: {
        async addExistingTag(id) {
            this.$showLoadingMessage();
            await this.getTagsList();
                if (!this.user.tags.includes(id)) {
                    const newTag = this.tagsList.find(tag => tag.id === id);
                    this.user.tags.push(newTag);
                    try {
                        await ApplicantsServices.addTagToApplicant(this.user.id, id);
                        this.$showSuccessMessage('Tag has been added')
                        this.inputTag = false
                        this.searchTerm = null
                    } catch (e) {
                        console.error(e);
                        this.$showErrorMessage('Tag was not added. Please refresh the page and try again.');
                    }
                } else {
                    this.$showErrorMessage(`This tag already exists.`);
                }
        },
        async createNewTag(newTag) {
            try {
                const {data: id} = await ApplicantsServices.addNewTag(newTag);
                await this.addExistingTag(id)
            } catch (error) {
                console.error(error);
            }
        },
        async deleteTag(id) {
            this.$showLoadingMessage();
            this.user.tags = this.user.tags.filter((tag) => tag.id !== id)
            try {
                this.$showSuccessMessageDelete();
                await ApplicantsServices.deleteUsersTag(this.user.id, id)
                $(`#modalId-${id}`).modal('hide');
            } catch (error) {
                this.$showErrorMessage('Tag was not added. Please refresh the page and try again.');
            }
        },
        editUserId (oldId) {
            this.newCustomUserId = oldId
            this.idInput = true
        },
        async getTagsList() {
            try {
                const {data: tags} = await CommonService.getListOfTags(this.searchTerm)
                this.tagsList = tags
            }  catch (e) {
            console.error(e)
            this.$showErrorMessage();
            }
        },
        async reactivateApplicant() {
            this.$showLoadingMessage();
            try {
                await DeactivationServices.reactivate(this.user.id)
                this.$showSuccessMessage('Applicant has been reactivated')
                setTimeout(() => {
                    location.reload();
                }, 1000)
            } catch (e) {
                console.error(e)
                this.$showErrorMessage('Applicant was not reactivated. Please try later')
            }
        },
        async saveNewUserId() {
            this.$showLoadingMessage();
            try {
                await ApplicantsServices.updateApplicantId(this.user.id, this.newCustomUserId)
                this.idInput = false
                this.customUserId = this.newCustomUserId
                this.$showSuccessMessage('User ID has been updated')
            } catch (e) {
                this.$showErrorMessage('User ID was not updated. Please try again')
            }

        },
        async saveTag() {
            if (this.searchTerm === null || this.searchTerm === '') {
                this.searchResults.length = 0
                this.inputTag = false
                this.showResults = false
            }
            else if (this.searchResults.includes(this.searchTerm)) {
                const foundTag = this.tagsList.find(tag => tag.name === this.searchTerm);
                const foundTagId = foundTag.id
                await this.addExistingTag(foundTagId);
            } else {
                await this.createNewTag(this.searchTerm);
            }
        },
        search() {
            this.showResults = true
            if (this.searchTerm !== null && this.searchTerm !== '') {
                const tagsOptions = this.tagsList.map(tag => (tag.name));
                this.searchResults = tagsOptions.filter(tag => tag.toLowerCase().includes(this.searchTerm.toLowerCase()));
            }
        },
        showInputTag() {
            this.inputTag = true
            this.showResults = true
        },
        selectResult(result) {
            this.searchTerm = result
            this.showResults = false
        },
        toggleShowAll() {
            this.showAll = !this.showAll;
            if (this.showAll) {
                this.limit = this.user.tags.length;
            } else {
                this.limit = 3;
            }
        },
        onImageSelected(event) {
            const file = event.target.files[0];
            if (file) {
                const reader = new FileReader();
                reader.onload = () => {
                    this.selectedFile = file;
                    this.uploadPhoto();
                };
                reader.readAsDataURL(file);
            }
        },
        async uploadPhoto() {
            this.$showLoadingMessage()
            if (this.selectedFile) {
                let formData = new FormData();
                formData.append('photo', this.selectedFile);
                try {
                    const response = await ApplicantsServices.uploadPhoto(this.user.id, formData);
                    this.avatar = response.data.url
                    this.getNameOfAvatar(this.avatar)
                    this.$showSuccessMessage('Your photo has been updated successfully')
                } catch (e) {
                    console.error(e);
                    this.$showErrorMessage("Your photo wasn't uploaded. Please try again");
                }
            }
        },
    },
    async mounted() {
        await this.getTagsList();
    },
}

</script>

<style scoped>
.search-results {
    list-style: none;
    margin: 0;
    padding: 0;
    position: absolute;
    width: 100%;
    background-color: #fff;
    border: 1px solid #ddd;
    border-top: none;
    z-index: 999;
    border-radius: 15px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    max-height: 120px;
    overflow-y: auto;
}

.search-results li {
    border-bottom:1px solid #ddd;
    padding: 10px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.search-results li:hover {
    background-color: #f0f0f0;
    border-radius: 15px;

}
.edit-image-btn {
    width: 32px;
    height: 32px;
    position: absolute;
    z-index: 4;
    display: flex;
    justify-content: center;
    align-self: center;
    bottom: 1rem;
    right: -0.5rem;
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.29);
    background-color: #fff;
    border-radius: 50%;
}

.edit-image-btn img {
    width: 1rem;
}

</style>
